const getSubdomainFromQuery = (url = window.location.href) => {
  return decodeURIComponent(url).replace(/.+\/\/|\..+/g, '');
};

export default getSubdomainFromQuery;
